import React, { useEffect, useState } from "react";
import { HeadingTitle } from "../ModalContainer";
import { Button } from "@material-ui/core";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { CloseBoxActions } from "../../../Actions/ProductionActions";
import Loading from "../../Loading/Loading";
import secureLocalStorage from "react-secure-storage";

const LevelDialog = ({
  close,
  key_id,
}) => {
  //   Close Box State
  const { close_box, loading } = useSelector((state) => state.ClosingBox);

  const [isClosed, setIsClosed] = useState(false);

  const handleCloseBox = () => {
    setIsClosed(true);
  };

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    if(key_id == 0){
      setDescription('Level-1: size, style and color same (single SKU)')
    }

    if(key_id == 1){
      setDescription('Level-2: size same, style same, color different')
    }

    if(key_id == 2){
      setDescription('Level-3: size same, color different, style different')
    }

    if(key_id == 3){
      setDescription('Level-4: size different, style different, color different')
    }
  },[]);

  return (
    <>
      <HeadingTitle title={title} center={false} closeModal={close} />
      <div className="confirmation-box-row">
        <p
          style={{
            fontFamily:
              title === "Create Box" || title === "Alert" ? "Poppins_Bold" : "",
          }}
        >
          {description === "Please Close Previous Box firstly"
            ? "Before creating a new box, could you please close the previous one?"
            : description}
        </p>
      </div>
    </>
  );
};

export default LevelDialog;
